import { render, staticRenderFns } from "./EditCompanyDetails.vue?vue&type=template&id=3f341430&scoped=true&"
import script from "./EditCompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EditCompanyDetails.vue?vue&type=style&index=0&id=3f341430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f341430",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCol,VFileInput,VForm,VRow,VTextField,VTextarea})
